(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.querySelectorAll('[data-announcement]').forEach((bar) => {
    const messages = [...bar.querySelectorAll('.bs-announcement__message')];
    if (messages.length < 2) return;
    const delay = Number(bar.dataset.interval || 6000);
    let index = 0;
    window.setInterval(() => {
      messages[index].hidden = true;
      index = (index + 1) % messages.length;
      messages[index].hidden = false;
    }, delay);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(() => {
  document.querySelectorAll('[data-header]').forEach((header) => {
    const toggle = header.querySelector('[data-nav-toggle]');
    const nav = header.querySelector('[data-nav]');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
function initGoodStillProduct(root) {
  if (root.dataset.productReady) return;
  root.dataset.productReady = 'true';
  const variantSelect = root.querySelector('[data-variant-select]');
  const sizeSelect = root.querySelector('[data-size-select]');
  const swatches = [...root.querySelectorAll('[data-color-swatch]')];
  const thumbs = [...root.querySelectorAll('[data-gallery-thumb]')];
  const mainImage = root.querySelector('[data-gallery-main]');
  const missingImage = root.querySelector('[data-gallery-missing]');
  const price = root.querySelector('[data-product-price]');
  const colorLabel = root.querySelector('[data-selected-color]');
  const addButton = root.querySelector('[data-add-button]');
  const quantityChoice = root.querySelector('[data-quantity-choice]');
  const quantityMore = root.querySelector('[data-quantity-more]');
  const quantityInput = root.querySelector('[data-quantity-input]');
  const quantityValue = root.querySelector('[data-quantity-value]');
  const options = variantSelect ? [...variantSelect.options] : [];
  let currentColor = options.find(option => option.selected)?.dataset.color || '';

  function showImage(thumb) {
    if (!thumb || !mainImage) return;
    mainImage.hidden = false;
    if (missingImage) missingImage.hidden = true;
    mainImage.src = thumb.dataset.imageSrc;
    mainImage.alt = thumb.dataset.imageAlt || '';
    thumbs.forEach(item => item.setAttribute('aria-current', item === thumb ? 'true' : 'false'));
    const rail = thumb.parentElement;
    if (rail) rail.scrollTo({ left: thumb.offsetLeft - rail.offsetLeft - 20, behavior: 'smooth' });
  }

  function showVariantImage(variant) {
    if (!variant || !mainImage) return;
    if (variant.dataset.imageSrc) {
      mainImage.hidden = false;
      if (missingImage) missingImage.hidden = true;
      mainImage.src = variant.dataset.imageSrc;
      mainImage.alt = variant.dataset.imageAlt || '';
      const chosenThumb = thumbs.find(thumb => thumb.dataset.mediaId === variant.dataset.mediaId);
      thumbs.forEach(thumb => thumb.setAttribute('aria-current', thumb === chosenThumb ? 'true' : 'false'));
      if (chosenThumb) chosenThumb.parentElement?.scrollTo({ left: chosenThumb.offsetLeft - chosenThumb.parentElement.offsetLeft - 20, behavior: 'smooth' });
      return;
    }
    let mediaId = variant.dataset.mediaId;
    if (!mediaId) {
      mediaId = options.find(option => option.dataset.color === currentColor && option.dataset.mediaId)?.dataset.mediaId;
    }
    if (!mediaId) {
      const mappedIds = new Set(options.map(option => option.dataset.mediaId).filter(Boolean));
      const unmappedColors = [...new Set(options.filter(option => !options.some(other => other.dataset.color === option.dataset.color && other.dataset.mediaId)).map(option => option.dataset.color))];
      const unmappedThumbs = thumbs.filter(thumb => !mappedIds.has(thumb.dataset.mediaId));
      if (unmappedColors.length === 1 && unmappedColors[0] === currentColor && unmappedThumbs.length === 1) {
        showImage(unmappedThumbs[0]);
      } else {
        mainImage.hidden = true;
        if (missingImage) missingImage.hidden = false;
        thumbs.forEach(thumb => thumb.setAttribute('aria-current', 'false'));
      }
      return;
    }
    showImage(thumbs.find(thumb => thumb.dataset.mediaId === mediaId));
  }

  function updateVariant(updateUrl) {
    if (!variantSelect || !sizeSelect) return;
    [...sizeSelect.options].forEach(size => {
      size.disabled = !options.some(option => option.dataset.size === size.value && option.dataset.color === currentColor && !option.disabled);
    });
    if (sizeSelect.selectedOptions[0]?.disabled) {
      sizeSelect.value = [...sizeSelect.options].find(size => !size.disabled)?.value || sizeSelect.value;
    }
    const match = options.find(option => option.dataset.size === sizeSelect.value && option.dataset.color === currentColor && !option.disabled);
    swatches.forEach(swatch => swatch.setAttribute('aria-pressed', swatch.dataset.color === currentColor ? 'true' : 'false'));
    if (colorLabel) colorLabel.textContent = currentColor;
    if (match) {
      variantSelect.value = match.value;
      price.textContent = match.dataset.price;
      addButton.disabled = false;
      addButton.textContent = addButton.dataset.addLabel;
      showVariantImage(match);
      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', match.value);
        window.history.replaceState({}, '', url);
      }
    } else {
      addButton.disabled = true;
      addButton.textContent = addButton.dataset.soldLabel;
    }
  }

  swatches.forEach(swatch => swatch.addEventListener('click', () => {
    currentColor = swatch.dataset.color;
    updateVariant(true);
  }));
  sizeSelect?.addEventListener('change', () => updateVariant(true));
  thumbs.forEach(thumb => thumb.addEventListener('click', () => showImage(thumb)));
  root.querySelector('[data-gallery-prev]')?.addEventListener('click', () => {
    const index = thumbs.findIndex(thumb => thumb.getAttribute('aria-current') === 'true');
    showImage(thumbs[(index - 1 + thumbs.length) % thumbs.length]);
  });
  root.querySelector('[data-gallery-next]')?.addEventListener('click', () => {
    const index = thumbs.findIndex(thumb => thumb.getAttribute('aria-current') === 'true');
    showImage(thumbs[(index + 1) % thumbs.length]);
  });
  let touchStart = 0;
  root.querySelector('[data-gallery-stage]')?.addEventListener('touchstart', event => { touchStart = event.changedTouches[0].screenX; }, { passive: true });
  root.querySelector('[data-gallery-stage]')?.addEventListener('touchend', event => {
    const distance = event.changedTouches[0].screenX - touchStart;
    if (Math.abs(distance) < 45 || thumbs.length < 2) return;
    const index = thumbs.findIndex(thumb => thumb.getAttribute('aria-current') === 'true');
    showImage(thumbs[(index + (distance < 0 ? 1 : -1) + thumbs.length) % thumbs.length]);
  }, { passive: true });

  function updateQuantity() {
    const isMore = quantityChoice.value === 'more';
    quantityMore.hidden = !isMore;
    quantityInput.disabled = !isMore;
    quantityInput.required = isMore;
    quantityValue.value = isMore ? quantityInput.value : quantityChoice.value;
  }
  quantityChoice?.addEventListener('change', updateQuantity);
  quantityInput?.addEventListener('input', updateQuantity);
  updateQuantity();
  if (variantSelect && currentColor) updateVariant(false);
}
function initGoodStillProducts() {
  document.querySelectorAll('[data-product-section]').forEach(initGoodStillProduct);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initGoodStillProducts);
else initGoodStillProducts();
document.addEventListener('shopify:section:load', initGoodStillProducts);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"]) return;
  try {
    
(()=>{const p=document.getElementById('GoodStillWelcomePopup');if(!p)return;const k='good-still-welcome-popup-seen';const o=()=>{p.hidden=false;document.body.style.overflow='hidden'},c=()=>{p.hidden=true;document.body.style.overflow='';try{localStorage.setItem(k,'1')}catch(e){}};let s=false;try{s=localStorage.getItem(k)==='1'}catch(e){}if(!s)setTimeout(o,1800);p.querySelectorAll('[data-popup-close]').forEach(e=>e.addEventListener('click',c));document.addEventListener('keydown',e=>{if(e.key==='Escape'&&!p.hidden)c()})})();

  } catch(e) { console.error(e); }
})();
})();
